// auth-config.ts
import { Configuration } from "@azure/msal-browser";

//prod
export const msalConfig: Configuration = {
  auth: {
    clientId: "daf50843-f38d-497b-9b15-424c24783138",
    authority:
      "https://login.ciam.daimlertruck.com/3db550f0-0c7f-439b-8e24-e32bf233615d/b2c_1a_signin_oidc_row",
    knownAuthorities: ["https://login.ciam.daimlertruck.com"],
    redirectUri: "https://supplierideas.daimlertruck.com/daimler-disc/dashboard/vave/request/list",
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
};

//QA

// export const msalConfig: Configuration = {
//   auth: {
//     clientId: "0395f8d7-58bd-46de-a6dd-4561407864d6",
//     authority:
//       "https://login-qa.ciam.daimlertruck.com/88f558f5-a216-470b-b34a-3164f5d6ec0f/b2c_1a_signin_oidc_row",
//     knownAuthorities: ["https://login-qa.ciam.daimlertruck.com"],
//     redirectUri: "https://supplierideas-qa.daimlertruck.com/dashboard/vave/request/list",
//   },
//   cache: {
//     cacheLocation: "localStorage",
//     storeAuthStateInCookie: true,
//   },
// };
